import React from 'react';
import Button from '@sizeid/commons/components/Button';
import colors from '@sizeid/assets/colors.json';
import { CONTACT_INDEX } from '@sizeid/shared/constants/routes';
import { WithTranslation } from 'next-i18next';

import P from 'components/typo/P';
import { withTranslation } from 'lib/i18n';

import PriceItem from './PriceItem';
import { variants } from './constants';
import Item from './PriceItem/Item';
import Wrap from './styled/Wrap';

const PriceList: React.FC<WithTranslation> = props => (
  <Wrap>
    <Item
      value={props.t('business.organizations.index.unlimited')}
      unit={props.t('business.organizations.index.unlimited_unit')}
    />
    <PriceItem
      amount={10}
      price={props.t('business.organizations.index.free')}
      priceUnit={props.t('business.organizations.index.free_unit')}
      color={colors.green.default}
    />
    {variants.map(variant => (
      <PriceItem
        key={variant.amount}
        amount={variant.amount}
        price={variant.price}
      />
    ))}
    <PriceItem>
      <>
        <Item
          value="10 000"
          unit={props.t('business.organizations.index.more_unit')}
        />
        <Button link={CONTACT_INDEX.route}>
          {props.t('business.organizations.index.contact_us')}
        </Button>
      </>
    </PriceItem>

    <P>{props.t('business.organizations.index.individual')}</P>
  </Wrap>
);

export default withTranslation('pages')(PriceList);
